<template>
  <div class="row">
    <b-col cols="12" v-if="results.message">
      <h4 class="table-controls-bg mt-3 p-3 mb-0">
        {{ results.message }}: {{ results.successRate }}
      </h4>
    </b-col>
    <b-col cols="12" v-if="results.success.length > 0" class="mt-3">
      <div>
        <h4 class="table-controls-bg p-3 mb-0">Results: Success</h4>
      </div>
      <b-table
        v-scrollTo
        small
        :fields="tableFields"
        :head-variant="'light'"
        :striped="false"
        :borderless="false"
        :outlined="false"
        :items="results.success"
      >
        <template v-slot:cell(details)="data">
          <b-table
            v-if="data.item.details"
            :head-variant="'light'"
            small
            :items="data.item.details"
          >
          </b-table>
        </template>
      </b-table>
    </b-col>
    <b-col cols="12" v-if="results.error.length > 0" class="mt-3">
      <div>
        <h4 class="table-controls-bg p-3 mb-0">Results: Failed</h4>
      </div>
      <b-table
        v-scrollTo
        small
        :fields="tableFields"
        :head-variant="'light'"
        :striped="false"
        :borderless="false"
        :outlined="false"
        :items="results.error"
      >
        <template v-slot:cell(details)="data">
          <b-table
            v-if="data.item.details"
            :head-variant="'light'"
            small
            :items="data.item.details"
          >
          </b-table>
        </template>
      </b-table>
    </b-col>
  </div>
</template>

<script>
export default {
  name: "table-results",
  props: {
    /**
     * Results data
     */
    results: {
      default: function () {
        return {};
      },
    },
    /**
     * Table fields
     */
    tableFields: {
      default: function () {
        return [];
      },
    },
  },
  components: {},
  data() {
    return {};
  },
  directives: {
    scrollTo: {
      // scroll element into view
      inserted: function (el) {
        el.scrollIntoView({ behavior: "smooth" });
      },
      update: function (el) {
        el.scrollIntoView({ behavior: "smooth" });
      },
    },
  },
};
</script>
